export const validationRegex = {
    coordinates: /^-?[0-9]{1,3}(?:\.[0-9]{1,})?$/,
    longitude: /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/
}